import { render, staticRenderFns } from "./menu-list.vue?vue&type=template&id=0f714e4e"
import script from "./menu-list.vue?vue&type=script&lang=js"
export * from "./menu-list.vue?vue&type=script&lang=js"
import style0 from "./menu-list.vue?vue&type=style&index=0&id=0f714e4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports